import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

const CountdownTimer = ({ expiresAt }) => {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    const expirationTime = new Date(expiresAt).getTime();

    const updateTimer = () => {
      const now = new Date().getTime();
      const diff = expirationTime - now;

      if (diff <= 0) {
        setTimeLeft(null); // Oculta o contador
        return;
      }

      const minutes = Math.floor(diff / 1000 / 60);
      const seconds = Math.floor((diff / 1000) % 60);

      setTimeLeft({ minutes, seconds });
    };

    updateTimer(); // Inicial
    const interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [expiresAt]);

  if (!timeLeft) return null; // Esconde o contador se expirou

  return (
    <Box style={{ fontWeight: 'bold' }}>
      Tempo restante: {String(timeLeft.minutes).padStart(2, '0')}:
      {String(timeLeft.seconds).padStart(2, '0')}
    </Box>
  );
};

export default CountdownTimer;
